import React, { useState, useEffect } from 'react'
import { addDoc, collection, getFirestore, getDocs } from 'firebase/firestore';
import { useBookingContext } from '../../context/BookingContext'
import NavbarPanel from '../NavbarPanel';
import { useParams } from 'react-router-dom';
import CommentsList from '../../microsites/CommentsList';
import { useLoginContext } from '../../context/LoginContext'
import Login from '../login/Login';
export default function CommentsCont() {
  const db = getFirestore()
  const [comments, setComments] = useState([])
const [changed, setChanged] = useState(false)
const {  loginCheck} = useLoginContext()



 const statusChanged = () => {
   if(changed === true) {
    setChanged(false)
   } else {
    setChanged(true)
   }
 }


  useEffect(() => {

    const QueryCollection = collection(db, `comments`)

    getDocs(QueryCollection)
      .then(resp => setComments(resp.docs.map(site => ({ id: site.id, ...site.data() }))))
      .catch((err) => console.log(err))


  }, [ changed])


  const [loginAnimation, setLoginAnimation] = useState(false)
  const [loginAnimation2, setLoginAnimation2] = useState(false)

  useEffect(() => {
    setLoginAnimation(true)

    setTimeout(() => {
      setLoginAnimation(false)


    }, 2000);
  }, [])


  return (
      <>
            {loginCheck != true ?

<div className={loginAnimation === true ? 'logincont loginlogoAnim' : 'logincont'}>

  <Login />
</div>
:  
    <>
      <div className='dashboardCont'>
        <NavbarPanel />
        <div className='bookOrderDashboardlistCol margintop'>
        <p className='sectionTittles'>| COMENTARIOS</p>
        
        <div>
        </div>

        <div className='commentListCont'>

    
        <CommentsList dashboard={true}  comments={comments} changed={statusChanged} />
        </div>
        </div>
      </div>
    </>
  }
   </>
  )
}
